export const baseUrl = '/home/';